import z from 'zod'

export const businessLineSchema = z.union([z.literal('RMC'), z.literal('AGG'), z.literal('CEM')])

export const shippingAddressSchema = z.object({
  lat: z.string(),
  lng: z.string(),
  siteId: z.string(),
  siteNumber: z.string(),
  customerId: z.string(),
  siteName: z.string(),
  street: z.string(),
  postalCode: z.string(),
  city: z.string(),
  country: z.string()
})

export const dateRangeDtoSchema = z.object({
  from: z.string(),
  to: z.string()
})

export const phoneNumberSchema = z.object({
  dialingCode: z.string().nullable(),
  number: z.string(),
  country: z.string()
})

export const contactSchema = z.object({
  name: z.string().optional(),
  phoneNumber: phoneNumberSchema.optional()
})
